import { LabelEmphasized, toSuperscript } from 'smoothie';

export interface FootnoteTitleProps {
    title: string;
    superscript?: number | '*';
    color?: string;
}

export const FootnoteTitle = ({
    title,
    superscript,
    color = '$gray1000',
}: FootnoteTitleProps) => {
    return (
        <LabelEmphasized color={color} lineHeight={16}>
            {superscript === '*'
                ? '* '
                : superscript != null
                  ? `${toSuperscript(superscript)} `
                  : ''}
            {title}
        </LabelEmphasized>
    );
};
